import { httpGet } from 'utils';
import { FilterConfigType, OffersType } from '../types';
import { getfilters } from '../helpers';

interface IFetchPortalActiveMarketsResponse {
  data?: OffersType[];
  count?: number;
}

interface IFetchPortalActiveMarketsParam {
  page?: number;
  pageSize?: number;
  searchText?: string;
  queryStr?: string;
  sortFilter?: string;
  sortOrder?: string;
  [key: string]: string | number | undefined;
}

export const fetchActiveMarkets = (
  params?: IFetchPortalActiveMarketsParam,
  filterConfig?: FilterConfigType,
): Promise<IFetchPortalActiveMarketsResponse> => {
  const path = `portal/PortalActiveMarkets`;

  const filterParams = getfilters(filterConfig);

  return httpGet<IFetchPortalActiveMarketsResponse, IFetchPortalActiveMarketsParam>(
    path,
    {
      pageSize: params?.pageSize,
      page: params?.page,
      ...filterParams,
      ...(params?.queryStr ? { queryStr: params.queryStr } : {}),
      ...(params?.sortFilter ? { sortFilter: params.sortFilter } : {}),
      ...(params?.sortOrder ? { sortOrder: params.sortOrder } : {}),
    },
    true,
  );
};
